import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const BIND_PAYMENT_TYPE = SERVER_URI + '/get-payment-type';
const CREATE_PAYMENT_TYPE = SERVER_URI + '/payment-type';
const UPDATE_STATUS = SERVER_URI + '/payment-type-status/'

const UPDATE_PAYMENT_TYPE = SERVER_URI + '/payment-type/'


export default {
    getPaymentType: async function (paylaod) {
        return apiPost(BIND_PAYMENT_TYPE, paylaod)

    },
    createPaymentType: async function (paylaod) {
        return apiPost(CREATE_PAYMENT_TYPE, paylaod)
    }
    ,
    updateStatus: async function (id) {
        return apiGet(UPDATE_STATUS + id)
    },
    updatePaymentType: async function (id, payload) {
        return apiPut(UPDATE_PAYMENT_TYPE + id, payload)
    }
};